import useMasterContext from "Context/MasterContext";
import "./index.css";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { useState, useContext, useEffect } from "react";
import {
  BASE_URL,
  GET_PHX_USER_DETAILS,
} from "utilFunctions/Constants/urlConstants";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { useLocation, useNavigate } from "react-router-dom";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import MyBatchesFacultyDetailTab from "Pages/MyBatches/MyBatchesFacultyDetailTab";
import { SINGLE_USER } from "utilFunctions/Constants/urlConstants";
import LeftArrow from "Assets/Icons/LeftArrow";
import Typography from "Components/CommonComponents/Typography";
import MyProfilePhoenixDetails from "Pages/MyProfile/MyProfilePhoenixDetails";
import { UserRoles } from "utilFunctions/Constants/UserRoles";
const MyProfileHome = () => {
  const navigate = useNavigate();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const [searchedFaculty] = useState<any>(null);
  const { masters } = useMasterContext();
  const location = useLocation();
  const { state } = location;
  const ToastDispatch = useContext(ToastContextDispatch);
  const [facultyDetail, setfacultyDetail] = useState<any>(null);
  const [facultyDetailPHX, setfacultyDetailPHX] = useState<any>(null);
  const { screen }: any = useWindowSize();
  const { makeRequest: GetFacultyData } = useGetApi(
    (data) => {
      console.log("GetFacultyData", data);
      if (
        data["data"] &&
        data["data"]["response"] &&
        data["data"]["response"].length
      ) {
        setfacultyDetail(data["data"]["response"][0]);
      }
    },
    (error) => {
      setfacultyDetail(null);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const { makeRequest: GetFacultyDataFromPHX } = useGetApi(
    (data) => {
      console.log("GetFacultyData", data);
      if (data["data"]) {
        setfacultyDetailPHX(data["data"]);
      }
    },
    (error) => {
      setfacultyDetailPHX(null);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  useEffect(() => {
    console.log(location.state, "locatio.state");
    const facultyId =
      location.pathname.split("/")[location.pathname.split("/").length - 1] ||
      "";
    const employeeId =
      location.state?.userProfile && location.state?.userProfile?.employeeId
        ? location.state?.userProfile?.employeeId
        : location.state?.userProfile?.name;
    if (employeeId) {
      const phxUrl =
        BASE_URL +
        GET_PHX_USER_DETAILS +
        "?facultyNameOrfacultyId=" +
        employeeId;
      GetFacultyDataFromPHX(phxUrl);
    }
    if (facultyId != "batches" && state) {
      const singleUrl = BASE_URL + SINGLE_USER + "/search?id=" + facultyId;
      GetFacultyData(singleUrl);
    } else {
      console.log(userInfo);
    }
  }, [userInfo, searchedFaculty, location]);

  return (
    <>
      {!["xs", "sm", "md"].includes(screen) && (
        <div
          className={
            "MyBatchesTableContainer d-flex p-2 align-items-center ml-5"
          }
        >
          <LeftArrow
            className={"cursorHoverCSS mr-2"}
            onClick={() => {
              if (userInfo.fexRole == UserRoles?.academicCounsellor) {
                navigate("/admin/myBranch", {
                  replace: true,
                  state: {
                    selectedStudent: null,
                  },
                });
              } else {
                navigate("/admin/dashboard", {
                  replace: true,
                  state: {
                    selectedStudent: null,
                  },
                });
              }
            }}
          />
          <Typography
            variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
            color="black"
          >
            {location.pathname === "/admin/batches" ? (
              "My Batches"
            ) : (
              <>
                {facultyDetail?.name} | {facultyDetail?.employeeId}
              </>
            )}
          </Typography>
        </div>
      )}

      <div
        className={["xs", "sm", "md"].includes(screen) ? "p-0 mt-3" : "pl-5"}
      >
        <MyBatchesFacultyDetailTab
          route={"myprofile"}
          facultyDetail={facultyDetail}
          screen={screen}
          branches={masters?.branches}
          regions={masters?.regions}
          streams={masters?.streams}
          subjects={masters}
        />
      </div>
      <div
        className={["xs", "sm", "md"].includes(screen) ? "p-0 mt-3" : "pl-5"}
      >
        <MyProfilePhoenixDetails
          route={"myprofile"}
          facultyDetail={facultyDetailPHX}
          screen={screen}
          branches={masters?.branches}
          regions={masters?.regions}
          streams={masters?.streams}
          subjects={masters}
        />
      </div>
    </>
  );
};

export default MyProfileHome;
